import { apiClient } from "./api";

export interface Workflow {
  id: string;
  name: string;
  definition: {
    trigger: { type: string; config: Record<string, unknown> };
    nodes: {
      id: string;
      type: string;
      config: Record<string, unknown>;
      next?: string[];
    }[];
  };
  created_at: string;
  updated_at: string;
}

export async function listWorkflows(): Promise<Workflow[]> {
  const response = await apiClient.get("/workflows");
  return response.data;
}

export async function createWorkflow(name: string, definition: Workflow["definition"]): Promise<Workflow> {
  const response = await apiClient.post("/workflows", { name, definition });
  return response.data;
}

export async function updateWorkflow(id: string, name: string, definition: Workflow["definition"]): Promise<Workflow> {
  const response = await apiClient.put(`/workflows/${id}`, { name, definition });
  return response.data;
}

export async function deleteWorkflow(id: string): Promise<void> {
  await apiClient.delete(`/workflows/${id}`);
}

export async function executeWorkflow(id: string, payload: Record<string, unknown>): Promise<{ status: string; logs: Record<string, unknown>[] }> {
  const response = await apiClient.post(`/workflows/${id}/execute`, { payload });
  return response.data;
}
